import { render, staticRenderFns } from "./EventTrend.vue?vue&type=template&id=1277f475&scoped=true"
import script from "./EventTrend.vue?vue&type=script&lang=js"
export * from "./EventTrend.vue?vue&type=script&lang=js"
import style0 from "./EventTrend.vue?vue&type=style&index=0&id=1277f475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277f475",
  null
  
)

export default component.exports